import { useState, useEffect } from 'react';
import _ from 'lodash';
import * as taxApi from '../../../lib/api/taxbill';

//@mui
import { Box } from '@mui/material';
import SalesBillHistoryList from '../../../components/projectmng/bill_mng/SalesBillHistoryList';
import { useDispatch, useSelector } from 'react-redux';
import { listProjectSalesTaxbills } from '../../../modules/projectModule/issue-taxbills';

//-----------------------------------------------------

//-----------------------------------------------------

const SalesBillHistoryContainer = ({ project, setIssueNo }) => {
  const [histories, setHistories] = useState([]);
  const dispatch = useDispatch();
  const { salesTaxbills } = useSelector(({ projectModule }) => ({
    salesTaxbills: projectModule.issueTaxbills.salesTaxbills,
  }));

  useEffect(() => {
    if (project) {
      dispatch(listProjectSalesTaxbills(project.prjUuid));
    }
  }, [project]);

  useEffect(() => {
    if (salesTaxbills) {
      const orderedLiist = _.orderBy(salesTaxbills, 'reqCompDt', 'desc');
      setHistories(salesTaxbills);
      setIssueNo(salesTaxbills.length + 1);    
    }
  }, [salesTaxbills, setIssueNo]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        m: 1,
      }}
    >
      <SalesBillHistoryList history={histories} />
    </Box>
  );
};

export default SalesBillHistoryContainer;
